import React from 'react';

// redux
import { useAppSelector } from 'reducers/useAppSelector';

// components
import { SegmentControlV2 } from '@zola/zola-ui/src/components/SegmentControlV2';
import PLPFacetBtn from 'pages/WebsiteDesignsPLPV2/components/PLPFacetBtn';

// helpers + utils
import { SEGMENTS, segments } from 'pages/WebsiteDesignsPLPV2/utils';

// styles
import {
  hideWhenDesktop,
  hideWhenNotTablet,
} from 'pages/WebsiteDesignsPLPV2/WebsiteDesignsPLPV2.styles';
import { MobileBarContainer, ResultsTxt } from './PLPMobileBar.styles';

export type PLPMobileBarProps = {
  handleToggleMobileMenu: () => void;
  onToggleLayout: (key: string | SEGMENTS) => void;
  setLayoutType: (key: string | SEGMENTS) => void;
};

const PLPMobileBar: React.FC<PLPMobileBarProps> = ({
  handleToggleMobileMenu,
  onToggleLayout,
  setLayoutType,
}) => {
  const resultsCount = useAppSelector(state => state.websitePlp.displayable_total);

  const handleToggleLayoutType = (key: string | SEGMENTS) => {
    setLayoutType(key);
    onToggleLayout(key);
  };

  return (
    <MobileBarContainer css={hideWhenDesktop} data-testid="PLPMobileBar">
      <div>
        <ResultsTxt>{resultsCount ? `${resultsCount} results` : ''}</ResultsTxt>
      </div>
      <div>
        <SegmentControlV2
          css={hideWhenNotTablet}
          segments={segments}
          onClick={handleToggleLayoutType}
        />
      </div>
      <div>
        <PLPFacetBtn handleToggleMobileMenu={handleToggleMobileMenu} />
      </div>
    </MobileBarContainer>
  );
};

export default PLPMobileBar;
